import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=3fccace7&scoped=true&"
import script from "./NotificationPanel.vue?vue&type=script&lang=ts&"
export * from "./NotificationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=3fccace7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fccace7",
  null
  
)

export default component.exports